import { style } from 'typestyle'

import { ITab, ITabContainer } from './type'
import css from './index.module.scss'
import { ToolTip } from '@ui/tooltip'


/** Контейнер под вкладки */
export const TabContainer = ({children, isVisible = true}: ITabContainer): React.JSX.Element => {
    return <>
        {!isVisible ? '' 
            : <div style={{ gap: '22px', display: 'flex', marginLeft: '30px' }}>
                {children}
            </div>
        }
    </>
}

export const TabItem = ({tabName, tabNameActive, children, tabToolTipTitle, tabToolTipPlace, onClick, tabDefaultColor = 'var(--background_primary)', tabActiveColor = 'var(--color_bg)'}: ITab): React.JSX.Element => {
    const tab = style({
        background: tabDefaultColor,
        $nest: {
            '&::after, &::before': {
                width: '15px',
                height: '15px',
                background: tabDefaultColor,
            },
            '&::after': {right: '-15px'},
            '&::before': {left: '-15px'},
        },
    })

    const tabContent = style({
        color: 'var(--color_bg_accent)',
        $nest: {
            '&::after, &::before': {
                width: '15px',
                height: '15px',
                background: tabDefaultColor,
            },
            '&::after': {right: '-15px'},
            '&::before': {left: '-15px'},
        },
    })
    
    const tabActive = style({
        padding: '4px 10px 8px 10px',
        background: tabActiveColor,
    })

    const tabContentActive = style({
        color: tabDefaultColor,
        $nest: {
            '&::after, &::before': {
                background: tabActiveColor,
            },
        },
    })
    
    return <>
        <ToolTip title={tabToolTipTitle} placement={tabToolTipPlace}>
            <div id={`toolTipTab_${tabName}`} className={tabNameActive === tabName ? `${css.tab} ${tab} ${css.tab_active} ${tabActive}` : `${css.tab} ${tab}`} onClick={() => onClick && onClick(tabName)}>
                <div className={`${css.tab_content} ${tabNameActive === tabName ? tabContentActive : '' } ${tabContent}`}>
                    {children}
                </div>
            </div>
        </ToolTip>
    </>
}